var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionDesert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "currentColor",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 36a2 2 0 0 1 2-2h36a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2Z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10a2 2 0 0 1 2 2v14h2v-2a2 2 0 1 1 4 0v2a4 4 0 0 1-4 4h-2v4h-4V24h-2a4 4 0 0 1-4-4v-4a2 2 0 1 1 4 0v4h2v-8a2 2 0 0 1 2-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionDesert);
export default __webpack_public_path__ + "static/media/ic_action_desert.5cf95f04f981f9893624c55e9ed0de3b.svg";
export { ForwardRef as ReactComponent };